export default "__VITE_ASSET__CT4tKZWv__"